var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconRevert = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--revert",
  viewBox: "0 0 28.6 20.5",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.7.8H7.3c-.4 0-.8.4-.8.8s.4.8.8.8h12.4c3.4 0 6.2 2.8 6.2 6.2s-2.8 6.2-6.2 6.2H3.8L5.7 13c.1-.1.2-.3.2-.6 0-.2-.1-.4-.2-.6-.3-.3-.8-.3-1.1 0L1.4 15v.1c0 .1-.1.1-.1.2-.3.3-.3.5-.2.7l.1.1s0 .1.1.1l3.2 3.2c.1.1.3.2.6.2.2 0 .4-.1.6-.2.3-.3.3-.8 0-1.1l-1.9-1.9h15.9c4.3 0 7.8-3.5 7.8-7.8S24 .8 19.7.8z",
  fill: "#282828"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRevert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconRevert.a99d92aa.svg";
export { ForwardRef as ReactComponent };